import { Injectable } from '@angular/core';
import { AuthService } from './Auth/auth.service';
import {
  isConnectComponent,
  applyConnectFieldValidators,
  getConnectComponentControl,
} from '../Shared Components/Utilities/utils';

@Injectable({
  providedIn: 'root',
})
/* istanbul ignore next */
export class ConnectComponentService {
  constructor(private readonly authService: AuthService) {}

  isConnectComponent(componentControl: any): boolean {
    return isConnectComponent(
      componentControl,
      this.authService.getConnectComponentIds()
    );
  }

  applyConnectFieldValidators(componentControl: any): void {
    applyConnectFieldValidators(
      componentControl,
      this.authService.getConnectComponentIds()
    );
  }

  getConnectComponentControl(components: any): any {
    return getConnectComponentControl(
      components,
      this.authService.getConnectComponentIds()
    );
  }
}
